import { AuthState } from './types'

export const initialState: AuthState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  isCheckingAuth: true, // Inicia como true para verificar auth ao carregar
  registerResult: null,
}

